// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { defaultCardStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsDefaultCard";
import { color, mergeWithCss } from "@werner/XDL/Utilities";
import { css } from "styled-components";

defaultCardStyles.mainWrapper = {
    css: css`
        margin-top: 16px;
        background: ${color("common.white")};
        padding: 20px;
        border: 1px solid ${color("primary", 0.05)};
        box-shadow: 0 0 15px 0 ${color("primary", 0.15)};
        border-top: 4px solid ${color("primary")};
    `,
};
